import {GetServerSideProps, NextPage} from "next";

import {Adsense} from "@ctrl/react-adsense/dist/adsense";
import {Config} from "../../components/config";
import {DownloadButton} from "../../components/share/DownloadButton";
import {Footer} from "../../components/modules/Footer/Footer";
import Head from "next/head";
import {Loader} from "../../components/common/Loader/Loader";
import {Navbar} from "../../components/modules/Navbar/Navbar";
import {ShareSocial} from "../../components/share/SocialShare";

interface IAttachmentDoc {
  id?: string;
  savedName?: string;
  name?: string;
  folderName?: string;
  imageUrl?: string;
  height?: number;
  width?: number;
  pageState: ImageViewPageState;
}
// // This
export const getServerSideProps: GetServerSideProps = async (context) => {
  const id = context.params?.id as string;

  var data = fetchImage(id);

  return { props: data };
};

async function fetchImage(imageId: string): Promise<IAttachmentDoc> {
  var doc: IAttachmentDoc = {
    pageState: ImageViewPageState.busy,
  };
  try {
    var res = await fetch(`${Config.attachmentBaseUrl}${imageId}`);
    if (res.ok) {
      var jsonData = await res.json();
      doc = {
        pageState: ImageViewPageState.loaded,
        id: jsonData.id,
        name: jsonData.name,
        imageUrl: jsonData.url,
        width: jsonData.width ?? null,
        height: jsonData.height ?? null,
      };
    }
    if (res.status == 404) {
      doc = {
        pageState: ImageViewPageState.notFound,
      };
      return doc;
    }
  } catch (e) {
    console.log(e);
  }

  return doc;
}

enum ImageViewPageState {
  busy,
  notFound,
  loaded,
}
const Page: NextPage = (props: any) => {
  var attachmentDoc = props;
  // console.log(attachmentDoc);
  //   const [attachmentDoc, setAttachmentDoc] = useState<
  //     IAttachmentDoc | undefined
  //   >();
  // const [imageUrl, setImageUrl] = useState('');
  // const [docId, setDocId] = useState('');
  // const [name, setName] = useState('');

  // useEffect(() => {

  //     if (!router.isReady) return;
  //     const { id } = router.query;
  //     fetchImage(id as any);
  // }, [router]);

  function renderSwitch() {
    switch (props.pageState) {
      case ImageViewPageState.busy:
        return (
          <div
            className=" flex h-96 items-center justify-center"
            style={
              {
                // position: "absolute",
                // top: "50%",
                // left: "50%",
                // transform: "translate(-50%, -50%)",
              }
            }
          >
            <Loader />
          </div>
        );
      case ImageViewPageState.loaded: {
        return (
          <div>
            <img
              src={attachmentDoc?.imageUrl}
              // width={props.width }
              // height={props.height }
              className="bg-white rounded-sm shadow-lg overflow-hidden"
              alt="Photo Collage Made With PhotoJoiner.com"
              style={{
                margin: "0 auto",
                maxHeight: "70vh",
              }}
            />
          </div>
        );
      }

      case ImageViewPageState.notFound: {
        return (
          <div className=" flex h-96 items-center justify-center">
            <div
              style={{
                display: "block",
                overflow: "hidden",
                fontWeight: "500",
                fontSize: "3rem",
                paddingRight: "10px",
                marginBottom: "10px",
                borderBottom: "1px solid rgba(0, 0, 0,.3)",
              }}
            >
              404
            </div>
            <div
              style={{
                padding: "20px",
                textAlign: "center",
                display: "inline",
                overflow: "hidden",
              }}
            >
              Not Found
            </div>
          </div>
        );
      }
    }
  }

    const shareUrl = `${Config.siteDomain}/shared-images/${
        attachmentDoc?.id ?? ""
    }`;

    return (
    <div>
      <Head>
        <title>Photo Collage Made With PhotoJoiner.com</title>
        <meta
          name="description"
          content="Photo collage made using PhotoJoiner.com collage editor"
        />

        <meta property="og:url" content={shareUrl} />
        <meta property="og:image" content={attachmentDoc?.imageUrl} />
        <meta property="og:image:url" content={attachmentDoc?.imageUrl} />
        <meta property="og:type" content="website" />
        <meta
          property="og:description"
          content="Photo collage made using photojoiner.com collage editor"
        />
        <meta
          property="og:title"
          content="Photo Collage Made With photojoiner.com"
        />
        <meta property="og:site_name" content="PhotoJoiner" />
        <meta property="fb:admins" content="513625245353504" />
        <meta property="fb:app_id" content="103844403148242" />
        {attachmentDoc?.height === undefined ? (
          ""
        ) : (
          <meta
            property="og:image:height"
            content={`${attachmentDoc!.height!}`}
          />
        )}

        {attachmentDoc?.width === undefined ? (
          ""
        ) : (
          <meta
            property="og:image:width"
            content={`${attachmentDoc!.width!}`}
          />
        )}

        <meta name="twitter:site" content="@photojoiner" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Photo Collage Made With PhotoJoiner.com"
        />
        <meta
          name="twitter:description"
          content="Photo collage made using PhotoJoiner.com collage editor"
        />
        <meta name="twitter:url" content={shareUrl} />
        <meta name="twitter:image" content={attachmentDoc?.imageUrl} />
      </Head>
      <Navbar backgroundColor="#FAFAFA" />

      <div className="block pt-24 ">
        <div className="">
          <div
            className="container"
            style={{
              position: "relative",
              margin: "0 auto",
              width: "100%",
              height: "100%",
            }}
          >
            <div
              className=" w-full   overflow-hidden
            "
              // style={{
              //   height: 90,
              // }}
            >
                {/*ad view mobile top*/}
              <Adsense
                className="block lg:hidden m-auto"
                style={{
                  width: 300,
                  height: 100,
                  backgroundColor: "#eeeeee38",
                }}
                // adTest="on"
                data-ad-format="horizontal"
                client="ca-pub-7908993773401181"
                slot="5274932230"
              />

                {/*ad view  top*/}
              <Adsense
                className=" m-auto hidden lg:block"
                style={{ width: 728, height: 90, backgroundColor: "#eeeeee38" }}
                // adTest="on"
                data-ad-format="horizontal"
                client="ca-pub-7908993773401181"
                slot="1299764874"
              />
            </div>
            <div className="flex flex-col-1 lg:flex-cols-3 py-6 justify-between  gap-4  w-full px-4">
              <div>
                  {/*ad view  left*/}
                <Adsense
                  className="hidden lg:block  "
                  style={{
                    width: 300,
                    height: 600,
                    backgroundColor: "#eeeeee38",
                  }}
                  // adTest="on"
                  client="ca-pub-7908993773401181"
                  slot="7937325416"
                />
              </div>
              <div>
                {/* Image View */}
                <div className="grow">{renderSwitch()}</div>
                  {/*ad view  right*/}
                <Adsense
                  className="block m-auto mt-5"
                  style={{
                    width: 300,
                    height: 100,
                    backgroundColor: "#eeeeee38",
                  }}
                  // adTest="on"
                  data-ad-format="horizontal"
                  client="ca-pub-7908993773401181"
                  slot="7709523885"
                />
              </div>

              <div>
                <Adsense
                  className=" hidden lg:block  "
                  style={{
                    width: 300,
                    height: 600,
                    backgroundColor: "#eeeeee38",
                  }}
                  // adTest="on"
                  client="ca-pub-7908993773401181"
                  slot="2310832325"
                />
              </div>
            </div>
          </div>

          {attachmentDoc !== undefined ? (
            <ShareSocial
              shareUrl={shareUrl}
              mediaUrl={attachmentDoc?.imageUrl ?? ""}
              fileName={attachmentDoc?.name ?? ""}
            />
          ) : (
            <div></div>
          )}
        </div>

        <div className="flex items-center justify-center py-5">
          {attachmentDoc !== undefined ? (
            <DownloadButton
              url={attachmentDoc!.imageUrl ?? ""}
              fileName={attachmentDoc?.name ?? ""}
            />
          ) : (
            <div></div>
          )}
        </div>
        <div className="pb-8"></div>
      </div>
      <Footer backgroundColor="#FAFAFA" textColor="black" titleColor="black" />
    </div>
  );
};

export default Page;
